export default "__VITE_ASSET__BnsCKj9c__"